export const BUILDING_NAME_EMPTY_ERROR: string = 'Building name cannot be empty';
export const BUILDING_NAME_EXISTS_ERROR: string = 'There\'s already an existing building with the same name. Please choose a different one';
export const EXTERNAL_ID_EMPTY_ERROR: string = 'External ID cannot be empty';
export const BUILDING_NAME_MAX_LENGTH_ERROR: string = 'Building name cannot exceed 50 characters';
export const COUNTRY_EMPTY_ERROR: string = 'A country must be selected';
export const STATE_EMPTY_ERROR: string = 'A state must be selected';
export const CITY_EMPTY_ERROR: string = 'A city must be selected';
